module.exports = __webpack_public_path__ + "static/media/RHS75.e7907d06.jpg";